import Link from 'next/link';

type Props = {
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
};

export default function HeaderLink({href, children, onClick}: Props) {
  return (
    <Link
      href={href}
      onClick={onClick}
      className="px-8 py-2 font-semibold hover:bg-gray-100 md:px-0 md:py-0 md:hover:bg-transparent md:hover:underline">
      {children}
    </Link>
  );
}
